import { useState } from "react";
import { Link } from "react-router-dom";
import { LockSimple, Sparkle, X } from "@phosphor-icons/react";

export function daysLeft(iso) {
  if (!iso) return 0;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / 86400000));
}

export const LockedCard = ({ title = "Subscribe to join the conversation", subtitle }) => (
  <div className="bg-white rounded-[2rem] p-7 border border-[#E6EBE4]/60 text-center" data-testid="paywall-locked">
    <div className="w-14 h-14 rounded-full bg-[#F4F1E8] flex items-center justify-center mx-auto mb-4">
      <LockSimple size={26} weight="duotone" color="#8A9A86" />
    </div>
    <h3 className="font-heading text-xl font-medium text-[#2C362B]">{title}</h3>
    <p className="text-[#6D7A6A] mt-1 mb-5">{subtitle || "Reading is always free. Become a member to post and comment."}</p>
    <Link to="/subscribe" className="inline-block bg-[#8A9A86] text-white hover:bg-[#6D7A6A] rounded-full px-7 py-3 font-semibold transition-all hover:-translate-y-0.5" data-testid="paywall-subscribe-btn">
      View membership
    </Link>
  </div>
);

export const TrialBadge = ({ sub }) => {
  if (!sub || sub.is_admin) return null;
  if (sub.status === "trial") {
    const d = daysLeft(sub.trial_ends_at);
    if (d <= 3) return null; // handled by the more prominent TrialNudge banner
    return (
      <Link to="/subscribe" className="flex items-center gap-2 bg-[#FDF0E6] border border-[#F8CDB0] text-[#D48A54] rounded-2xl px-4 py-3 text-sm font-semibold mb-6 hover:bg-[#fce6d4] transition-colors" data-testid="trial-badge">
        <Sparkle size={18} weight="fill" />
        Free trial · {d} day{d === 1 ? "" : "s"} left. Tap to become a member.
      </Link>
    );
  }
  return null;
};

export const TrialNudge = ({ sub }) => {
  const todayKey = new Date().toISOString().slice(0, 10);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("trial_nudge_" + todayKey) === "1"
  );
  if (!sub || sub.is_admin || sub.status !== "trial" || dismissed) return null;
  const d = daysLeft(sub.trial_ends_at);
  if (d > 3) return null;
  const ending = d <= 1;
  const dismiss = () => {
    localStorage.setItem("trial_nudge_" + todayKey, "1");
    setDismissed(true);
  };
  const label =
    d === 0 ? "Your free trial ends today" : d === 1 ? "Your free trial ends tomorrow" : `Your free trial ends in ${d} days`;
  return (
    <div
      data-testid="trial-nudge"
      className={`w-full border-b ${ending ? "bg-[#FBEAE7] border-[#F5C7C0]" : "bg-[#FDF0E6] border-[#F8CDB0]"}`}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3">
        <p className={`text-sm font-semibold ${ending ? "text-[#D97B6A]" : "text-[#D48A54]"}`}>
          <Sparkle size={15} weight="fill" className="inline mb-0.5 mr-1.5" />
          {label} — keep posting & replying for $7.77/mo.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/subscribe"
            data-testid="trial-nudge-cta"
            className="bg-[#8A9A86] text-white hover:bg-[#6D7A6A] rounded-full px-4 py-1.5 text-sm font-semibold transition-all hover:-translate-y-0.5 whitespace-nowrap"
          >
            Become a member
          </Link>
          <button onClick={dismiss} data-testid="trial-nudge-dismiss" className="text-[#C9B8A8] hover:text-[#6D7A6A] transition-colors p-1" title="Dismiss for today">
            <X size={16} weight="bold" />
          </button>
        </div>
      </div>
    </div>
  );
};
